import { styled, CSS } from '@/stitches.config';
import { ReactNode } from 'react';

interface FilterWrapperProps {
  children: ReactNode;
  css?: CSS;
}

export function FilterWrapper({ children, css }: FilterWrapperProps) {
  return <Wrapper css={css}>{children}</Wrapper>;
}

const Wrapper = styled('div', {
  '--item-width': '8em',

  position: 'relative',
  width: '100%',
  display: 'inline-flex',
  flexDirection: 'column',

  '@bp2': {
    width: 'calc(var(--item-width) * 4)',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid $gray8',
  },

  '& > *:first-child': {
    borderTop: '1px solid $gray8',
    '@bp2': {
      borderTop: 'none',
    },
  },
});
